import styled from '@emotion/styled';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMap from 'highcharts/modules/map';
import { Ref } from 'react';

import { useHighchartsMapOptions } from './MapWidget.helpers';

import RefObject = HighchartsReact.RefObject;

HighchartsMap(Highcharts);

interface HighChartsWrapperProps {
  mapRef: Ref<RefObject>;
}

const StyledHighchartsMapWrapper = styled.div`
  position: absolute;

  // prevent click effect on legend
  .highcharts-legend,
  .highcharts-point,
  .highcharts-label {
    pointer-events: none !important;
  }

  // overwrite pointer events for axis labels to allow for
  // double click to open chart panel
  .highcharts-axis-labels {
    pointer-events: none !important;
  }

  // SVGs must have absolute positioning to render correctly on export
  svg.highcharts-root {
    position: absolute;
  }
`;

export const HighchartsMapWrapper = ({ mapRef }: HighChartsWrapperProps) => {
  const highchartsOptions = useHighchartsMapOptions();
  /**
   * Highcharts wrapper must have aria-hidden set to TRUE so that
   * text labels (data, x, y axes) are not picked up in the reading
   * order after export.
   */

  return (
    <StyledHighchartsMapWrapper aria-hidden={true}>
      <HighchartsReact
        ref={mapRef}
        immutable={true}
        highcharts={Highcharts}
        options={highchartsOptions}
        constructorType={'mapChart'}
      />
    </StyledHighchartsMapWrapper>
  );
};
